module.exports = __webpack_public_path__ + "assets/webgl/card_verso_L0.6ba58254.jpg";